import React from "react";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="ph-footer py-5">
      <div className="container">
        <div className="row g-4 justify-content-center align-items-center text-center text-lg-start">
          {/* LEFT — MAP */}
          <div className="col-12 col-lg-4 pb-3">
            <div className="map-wrap">
              <iframe
                title="Pizza Home Debrecen – Google Térkép"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2708.957512345678!2d21.627312!3d47.531604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47470c2f0a0a0a0a%3A0x1111111111111111!2zRGVicmVjZW4!5e0!3m2!1shu!2shu!4v1760000000000!5m2!1shu!2hu"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* CENTER — LOGO + COPYRIGHT */}
          <div className="col-12 col-lg-4 d-flex flex-column align-items-center text-center pb-3">
            <img
              src="/images/logo.webp"
              alt="Pizza Home Debrecen logó"
              className="ph-footer-logo mb-3"
            />
            <p className="ph-copy mb-0">
              Minden jog fenntartva – Farády Tamás E.V. ©2025
            </p>
          </div>

          {/* RIGHT — PDF THUMB + PAYMENT TEXT */}
          <div className="col-12 col-lg-4 text-center text-lg-start pb-3">
            <h3 className="ph-footer-title mb-3">Fizetési lehetőségek</h3>
            <p className="mb-3">
              OTP SZÉP kártyát és bármilyen bankkártyát elfogadunk
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
